import React, { useState, useEffect, useRef } from 'react'
import * as S from './styles'
import logo2 from 'assets/images/logo-martinsdv.png'
import MarcaYrm from 'components/Loader/MarcaYrm'
import { AiOutlineSearch, AiOutlinePlus } from 'react-icons/ai'
import { MdMenu } from 'react-icons/md'
import { FaCalendarAlt, FaUser, FaFileAlt, FaPaperclip } from 'react-icons/fa'
import { message, Tooltip } from 'antd'
import { CloseOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons'
import { LuPanelLeft } from 'react-icons/lu'
import EquipeOnline from 'components/Container/EquipeOnline'
import { useTema } from 'theme/tema'
import { useNavigate } from 'react-router-dom'
import dayjs from 'utils/dayjsUtc';
import Profile from '../UserProfile'
import NotificationCenter from '../NotificationCenter'
import { globalSearch, VAZIO } from 'services/search/globalSearch'
import viewFile from 'services/files/view'
import EditClient from 'components/Clients/ClientsActions/EditClient'
import NewProcess from 'components/Processes/Filters/New'
import ScheduleProcess from 'components/Processes/ProcessActions/ScheduleProcess'
import { useNotifications } from 'contexts/NotificationContext'

const naturezaColorMap = (naturezaRaw) => {
  if (!naturezaRaw) return {};
  const n = naturezaRaw.toLowerCase();
  // Normaliza palavras chave
  if (n.includes('cível') || n.includes('civel')) {
    return {
      $bg: 'linear-gradient(135deg,#e6f4ff 0%, #f0faff 100%)',
      $color: '#0b64b0',
      $border: '#3da5ff33',
      $shadow: 'rgba(61,165,255,0.18)',
      $hoverShadow: 'rgba(61,165,255,0.28)',
      $hoverBorder: '#3da5ff66'
    }
  }
  if (n.includes('trabalh') || n.includes('trabalhista')) {
    return {
      $bg: 'linear-gradient(135deg,#fff5e6 0%, #fff9f0 100%)',
      $color: '#b35300',
      $border: '#ffb64d55',
      $shadow: 'rgba(255,182,77,0.25)',
      $hoverShadow: 'rgba(255,182,77,0.38)',
      $hoverBorder: '#ffb64d88'
    }
  }
  if (n.includes('penal') || n.includes('criminal')) {
    return {
      $bg: 'linear-gradient(135deg,#ffe6e6 0%, #fff2f2 100%)',
      $color: '#911b1b',
      $border: '#ff6b6b55',
      $shadow: 'rgba(255,107,107,0.25)',
      $hoverShadow: 'rgba(255,107,107,0.38)',
      $hoverBorder: '#ff6b6b88'
    }
  }
  if (n.includes('tribut') || n.includes('fiscal')) {
    return {
      $bg: 'linear-gradient(135deg,#e6fff3 0%, #f2fff8 100%)',
      $color: '#056642',
      $border: '#2dd69f44',
      $shadow: 'rgba(45,214,159,0.25)',
      $hoverShadow: 'rgba(45,214,159,0.38)',
      $hoverBorder: '#2dd69f77'
    }
  }
  if (n.includes('famil') || n.includes('família')) {
    return {
      $bg: 'linear-gradient(135deg,#fbe8ff 0%, #fcf3ff 100%)',
      $color: '#7b1fa2',
      $border: '#d97bff44',
      $shadow: 'rgba(217,123,255,0.25)',
      $hoverShadow: 'rgba(217,123,255,0.38)',
      $hoverBorder: '#d97bff77'
    }
  }
  // fallback
  return {
    $bg: 'linear-gradient(135deg,#e6f4ff 0%, #f0f8ff 100%)',
    $color: '#0b64b0',
    $border: '#3da5ff33',
    $shadow: 'rgba(61,165,255,0.18)',
    $hoverShadow: 'rgba(61,165,255,0.28)',
    $hoverBorder: '#3da5ff66'
  }
}

function TopBar({ onToggleMobile, isMobile, menuAberto, onAlternarMenu }) {
  const [searchFocus, setSearchFocus] = useState(false)
  // celular: a busca abre por cima do topo (o campo não cabe ao lado dos botões)
  const [buscaAberta, setBuscaAberta] = useState(false)
  const campoBuscaRef = useRef(null)
  // Ctrl+K (Cmd+K no Mac) leva à busca de qualquer tela
  useEffect(() => {
    const atalho = (e) => {
      if ((e.ctrlKey || e.metaKey) && String(e.key).toLowerCase() === 'k') {
        e.preventDefault()
        campoBuscaRef.current?.focus()
      }
    }
    window.addEventListener('keydown', atalho)
    return () => window.removeEventListener('keydown', atalho)
  }, [])
  const abrirBusca = () => { setBuscaAberta(true); setTimeout(() => campoBuscaRef.current?.focus(), 0) }
  const [showNewMenu, setShowNewMenu] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState(VAZIO)
  const [showSearchResults, setShowSearchResults] = useState(false)
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('all') 

  const [selectedClient, setSelectedClient] = useState(null)
  const [selectedProcess, setSelectedProcess] = useState(null)
  const [showEditClient, setShowEditClient] = useState(false)
  const [showEditProcess, setShowEditProcess] = useState(false)
  const [showQuickSchedule, setShowQuickSchedule] = useState(false)
  
  const navigate = useNavigate()
  const { escuro, alternar } = useTema()
  // Notificação nova em tempo real (socket) faz o sino recontar
  const { notifications } = useNotifications()
  
  const dropdownRef = useRef(null)
  const searchRef = useRef(null)
  const searchTimeoutRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNewMenu(false)
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchResults(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleSearch = async (value) => {
    // Mantém o valor visual digitado ou colado no input
    setSearchQuery(value)
    
    // Tratamento robusto para Copy & Paste de PDFs, e-mails ou mensagens:
    // 1. Substitui quebras de linha (\r, \n) e tabulações (\t) por espaços
    // 2. Substitui espaços inquebráveis (\u00a0) comumente gerados em cópias por espaços comuns
    // 3. Reduz múltiplos espaços em sequência para apenas um único espaço
    // 4. Remove espaços inúteis no início e fim do texto (.trim())
    const searchTerm = value
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()

    // Valida o comprimento usando o termo já sanitizado
    if (!searchTerm || searchTerm.length < 2) {
      setSearchResults(VAZIO)
      setShowSearchResults(false)
      return
    }

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    searchTimeoutRef.current = setTimeout(async () => {
      setLoading(true)
      try {
        // Envia o termo limpo e higienizado para o serviço de busca
        const results = await globalSearch(searchTerm)
        setSearchResults(results)
        setShowSearchResults(true)
      } catch (error) {
        console.error('Erro na busca:', error)
      } finally {
        setLoading(false)
      }
    }, 300)
  }

  const handleClientClick = (client) => {
    const params = new URLSearchParams()
    params.set(client.cpf ? 'cpf' : 'nome', client.cpf || client.nome)
    navigate(`/clients?${params.toString()}`)
    setShowSearchResults(false)
    setSearchQuery('')
  }

  const handleProcessClick = (process) => {
    setSelectedProcess(process)
    setShowEditProcess(true)
    setShowSearchResults(false)
    setSearchQuery('')
  }

  const handleScheduleClick = (schedule) => {
    const params = new URLSearchParams()
    params.set('search', searchQuery.trim())
    if (schedule?.date) params.set('date', dayjs.utc(schedule.date).format('YYYY-MM-DD'))
    navigate(`/schedule?${params.toString()}`)
    setShowSearchResults(false)
    setSearchQuery('')
  }

  const handleFileClick = async (arquivo) => {
    setShowSearchResults(false)
    setSearchQuery('')
    // Abre a aba já no clique: aberta depois da espera, o navegador bloqueia
    const janela = window.open('', '_blank')
    try {
      const { data } = await viewFile(arquivo.id)
      if (janela) janela.location.href = data.url
      else window.location.href = data.url
    } catch (error) {
      janela?.close()
      message.error('Não foi possível abrir o arquivo.')
    }
  }

  const renderFile = (arquivo) => (
    <S.SearchResultItem key={`file-${arquivo.id}`} onClick={() => handleFileClick(arquivo)}>
      <S.SearchResultMain>{arquivo.nome}</S.SearchResultMain>
      <S.SearchResultSub>
        {[arquivo.clienteNome, arquivo.processoNumero, dayjs(arquivo.criadoEm).format('DD/MM/YYYY')].filter(Boolean).join(' • ')}
      </S.SearchResultSub>
    </S.SearchResultItem>
  )

  const totalResultados = searchResults.processes.length + searchResults.clients.length + searchResults.schedules.length + searchResults.files.length

  const handleNewAction = (action) => {
    setShowNewMenu(false)
    if (action === 'process') {
      setSelectedProcess(null)
      setShowEditProcess(true)
    } else if (action === 'client') {
      setSelectedClient(null)
      setShowEditClient(true)
    } else if (action === 'schedule') {
      setShowQuickSchedule(true)
    }
  }

  return (
    <S.TopBar>
      <S.LeftSection>
        {isMobile && (
          <S.MobileMenuButton onClick={onToggleMobile}>
            <MdMenu size={24} />
          </S.MobileMenuButton>
        )}
        
        <S.LogoContainer>
          <img src={logo2} alt='YRM' />
        </S.LogoContainer>
        {!isMobile && onAlternarMenu && (
          <Tooltip title={menuAberto ? 'Recolher menu' : 'Expandir menu'} placement='bottom'>
            <S.IconeTopo type='button' onClick={() => onAlternarMenu()} aria-label={menuAberto ? 'Recolher menu' : 'Expandir menu'} aria-expanded={menuAberto}>
              <LuPanelLeft />
            </S.IconeTopo>
          </Tooltip>
        )}
        
        <S.SearchContainer $focused={searchFocus} $aberta={buscaAberta} ref={searchRef}>
          <S.SearchIcon>
            <AiOutlineSearch size={20} />
          </S.SearchIcon>
          <S.SearchInput 
            ref={campoBuscaRef}
            type="text" 
            placeholder="Buscar processo, cliente, agenda ou arquivo... (Ctrl+K)"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            onFocus={() => setSearchFocus(true)}
            onBlur={(e) => {
              setTimeout(() => {
                if (!searchRef.current?.contains(document.activeElement)) {
                  setSearchFocus(false)
                }
              }, 100)
            }}
          />
            
          {showSearchResults && searchQuery.trim().length >= 2 && (
            <S.SearchResultsDropdown>
              <S.SearchTabs>
                <S.SearchTab 
                  active={activeTab === 'all'} 
                  onClick={() => setActiveTab('all')}
                >
                  Tudo ({totalResultados})
                </S.SearchTab>
                <S.SearchTab 
                  active={activeTab === 'processes'} 
                  onClick={() => setActiveTab('processes')}
                >
                  Processos ({searchResults.processes.length})
                </S.SearchTab>
                <S.SearchTab 
                  active={activeTab === 'clients'} 
                  onClick={() => setActiveTab('clients')}
                >
                  Clientes ({searchResults.clients.length})
                </S.SearchTab>
                <S.SearchTab
                  active={activeTab === 'schedules'}
                  onClick={() => setActiveTab('schedules')}
                >
                  Agenda ({searchResults.schedules.length})
                </S.SearchTab>
                <S.SearchTab
                  active={activeTab === 'files'}
                  onClick={() => setActiveTab('files')}
                >
                  Arquivos ({searchResults.files.length})
                </S.SearchTab>
              </S.SearchTabs>

              <S.SearchTabContent>
                {activeTab === 'all' && (
                  <>
                    {loading ? (
                      <S.SearchResultItem>
                        <S.SearchResultMain role='status' aria-label='Buscando'><MarcaYrm pequena /></S.SearchResultMain>
                      </S.SearchResultItem>
                    ) : (
                      <>
                        {searchResults.processes.length > 0 && (
                          <S.SearchResultsSection>
                            <S.SearchResultsTitle>
                              <FaFileAlt size={14} />
                              Processos
                            </S.SearchResultsTitle>
                            {searchResults.processes.map((process) => (
                              <S.SearchResultItem
                                key={`process-${process.id}`}
                                onClick={() => handleProcessClick(process)}
                              >
                                <S.SearchResultMain style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
                                  <span>{process.NProcesso}</span>
                                  {process.Natureza && (
                                    <S.NaturezaTag title={process.Natureza} {...naturezaColorMap(process.Natureza)}>
                                      {process.Natureza}
                                    </S.NaturezaTag>
                                  )}
                                </S.SearchResultMain>
                                <S.SearchResultSub>
                                  {process.PartePROPrincipalNome} • {process.Status}
                                </S.SearchResultSub>
                              </S.SearchResultItem>
                            ))}
                          </S.SearchResultsSection>
                        )}

                        {searchResults.clients.length > 0 && (
                          <S.SearchResultsSection>
                            <S.SearchResultsTitle>
                              <FaUser size={14} />
                              Clientes
                            </S.SearchResultsTitle>
                            {searchResults.clients.map((client) => (
                              <S.SearchResultItem
                                key={`client-${client.id}`}
                                onClick={() => handleClientClick(client)}
                              >
                                <S.SearchResultMain>
                                  {client.nome}
                                </S.SearchResultMain>
                                <S.SearchResultSub>
                                  CPF: {client.cpf} • {client.cidade || 'N/A'}
                                </S.SearchResultSub>
                              </S.SearchResultItem>
                            ))}
                          </S.SearchResultsSection>
                        )}

                        {searchResults.schedules.length > 0 && (
                          <S.SearchResultsSection>
                            <S.SearchResultsTitle>
                              <FaCalendarAlt size={14} />
                              Agenda
                            </S.SearchResultsTitle>
                            {searchResults.schedules.map((schedule) => (
                              <S.SearchResultItem
                                key={`schedule-${schedule.id}`}
                                onClick={() => handleScheduleClick(schedule)}
                              >
                                <S.SearchResultMain>
                                  {dayjs.utc(schedule.date).format('DD/MM/YYYY')} às {schedule.hour || '--:--'} · {schedule.title || 'Compromisso'}
                                </S.SearchResultMain>
                                <S.SearchResultSub>
                                  {schedule.processNumber || 'Sem processo'}
                                  {schedule.category ? ` • ${schedule.category}` : ''}
                                  {schedule.responsavelNames ? ` • ${schedule.responsavelNames}` : ''}
                                </S.SearchResultSub>
                              </S.SearchResultItem>
                            ))}
                          </S.SearchResultsSection>
                        )}

                        {searchResults.files.length > 0 && (
                          <S.SearchResultsSection>
                            <S.SearchResultsTitle>
                              <FaPaperclip size={14} />
                              Arquivos
                            </S.SearchResultsTitle>
                            {searchResults.files.map(renderFile)}
                          </S.SearchResultsSection>
                        )}

                        {totalResultados === 0 && (
                          <S.EmptySearchResults>
                            Nenhum resultado encontrado
                          </S.EmptySearchResults>
                        )}
                      </>
                    )}
                  </>
                )}

                {activeTab === 'processes' && (
                  <>
                    {loading ? (
                      <S.SearchResultItem>
                        <S.SearchResultMain>Buscando processos...</S.SearchResultMain>
                      </S.SearchResultItem>
                    ) : searchResults.processes.length > 0 ? (
                      searchResults.processes.map((process) => (
                        <S.SearchResultItem
                          key={process.id}
                          onClick={() => handleProcessClick(process)}
                        >
                          <S.SearchResultMain style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
                            <span>{process.NProcesso}</span>
                            {process.Natureza && (
                              <S.NaturezaTag title={process.Natureza} {...naturezaColorMap(process.Natureza)}>
                                {process.Natureza}
                              </S.NaturezaTag>
                            )}
                          </S.SearchResultMain>
                          <S.SearchResultSub>
                            {process.ParteCONPrincipalNome} • {process.Status}
                          </S.SearchResultSub>
                        </S.SearchResultItem>
                      ))
                    ) : (
                      <S.EmptySearchResults>
                        Nenhum processo encontrado
                      </S.EmptySearchResults>
                    )}
                  </>
                )}

                {activeTab === 'clients' && (
                  <>
                    {loading ? (
                      <S.SearchResultItem>
                        <S.SearchResultMain>Buscando clientes...</S.SearchResultMain>
                      </S.SearchResultItem>
                    ) : searchResults.clients.length > 0 ? (
                      searchResults.clients.map((client) => (
                        <S.SearchResultItem
                          key={client.id}
                          onClick={() => handleClientClick(client)}
                        >
                          <S.SearchResultMain>
                            {client.nome}
                          </S.SearchResultMain>
                          <S.SearchResultSub>
                            CPF: {client.cpf} • {client.cidade || 'N/A'}
                          </S.SearchResultSub>
                        </S.SearchResultItem>
                      ))
                    ) : (
                      <S.EmptySearchResults>
                        Nenhum cliente encontrado
                      </S.EmptySearchResults>
                    )}
                  </>
                )}

                {activeTab === 'schedules' && (
                  <>
                    {loading ? (
                      <S.SearchResultItem>
                        <S.SearchResultMain>Buscando compromissos...</S.SearchResultMain>
                      </S.SearchResultItem>
                    ) : searchResults.schedules.length > 0 ? (
                      searchResults.schedules.map((schedule) => (
                        <S.SearchResultItem
                          key={schedule.id}
                          onClick={() => handleScheduleClick(schedule)}
                        >
                          <S.SearchResultMain>
                            {dayjs.utc(schedule.date).format('DD/MM/YYYY')} às {schedule.hour || '--:--'} · {schedule.title || 'Compromisso'}
                          </S.SearchResultMain>
                          <S.SearchResultSub>
                            {schedule.processNumber || 'Sem processo'}
                            {schedule.category ? ` • ${schedule.category}` : ''}
                            {schedule.responsavelNames ? ` • ${schedule.responsavelNames}` : ''}
                          </S.SearchResultSub>
                        </S.SearchResultItem>
                      ))
                    ) : (
                      <S.EmptySearchResults>
                        Nenhum compromisso encontrado
                      </S.EmptySearchResults>
                    )}
                  </>
                )}

                {activeTab === 'files' && (
                  loading ? (
                    <S.SearchResultItem>
                      <S.SearchResultMain>Buscando arquivos...</S.SearchResultMain>
                    </S.SearchResultItem>
                  ) : searchResults.files.length > 0 ? (
                    searchResults.files.map(renderFile)
                  ) : (
                    <S.EmptySearchResults>Nenhum arquivo encontrado</S.EmptySearchResults>
                  )
                )}
              </S.SearchTabContent>
            </S.SearchResultsDropdown>
          )}
          {buscaAberta && (
            <S.FecharBusca type='button' aria-label='Fechar busca' onClick={() => setBuscaAberta(false)}>
              <CloseOutlined />
            </S.FecharBusca>
          )}
        </S.SearchContainer>
      </S.LeftSection>

      <S.RightSection>
        <S.BotaoBusca type='button' aria-label='Buscar' onClick={abrirBusca}>
          <AiOutlineSearch />
        </S.BotaoBusca>
        {!isMobile && <EquipeOnline />}

        <S.ActionButtonContainer ref={dropdownRef}>
          <S.ActionButton 
            title="Adicionar novo"
            onClick={() => {
              if (isMobile) {
                handleNewAction('process')
              } else {
                setShowNewMenu(!showNewMenu)
              }
            }}
          >
            <AiOutlinePlus size={20} />
            {isMobile ? <span>Novo Processo</span> : <span>Novo</span>}
          </S.ActionButton>
          
          {showNewMenu && (
            <S.DropdownMenu>
              <S.DropdownItem onClick={() => handleNewAction('process')}>
                Novo Processo
              </S.DropdownItem>
              <S.DropdownItem onClick={() => handleNewAction('client')}>
                Novo contato
              </S.DropdownItem>
              <S.DropdownItem onClick={() => handleNewAction('schedule')}>
                Novo Agendamento
              </S.DropdownItem>
            </S.DropdownMenu>
          )}
        </S.ActionButtonContainer>
        
        <Tooltip title={escuro ? 'Modo claro' : 'Modo escuro'}>
          <S.IconeTopo type='button' onClick={alternar} aria-label={escuro ? 'Ativar modo claro' : 'Ativar modo escuro'} aria-pressed={escuro}>
            {escuro ? <SunOutlined /> : <MoonOutlined />}
          </S.IconeTopo>
        </Tooltip>

        <NotificationCenter atualizarQuando={notifications?.[0]?.id} />

        <S.UserSection>
          {!isMobile && (
            <S.UserInfo>
              <Profile/>
            </S.UserInfo>
          )}
        </S.UserSection>
      </S.RightSection>
      
      {showEditClient && (
        <EditClient
          clientData={selectedClient} 
          newClient={!selectedClient} 
          open={showEditClient}
          onOpenChange={setShowEditClient}
          successCallback={() => {
            setShowEditClient(false)
            setSelectedClient(null)
          }}
        />
      )}
      
      {showEditProcess && (
        <NewProcess
          key={selectedProcess?.id || 'novo-processo'}
          isEditing={!!selectedProcess}
          process={selectedProcess} 
          visible={showEditProcess}
          onVisibleChange={setShowEditProcess}
          onCancel={() => {
            setShowEditProcess(false)
            setSelectedProcess(null)
          }}
          successCallback={() => {
            setShowEditProcess(false)
            setSelectedProcess(null)
          }}
        />
      )}

      <ScheduleProcess
        processN=""
        open={showQuickSchedule}
        onOpenChange={setShowQuickSchedule}
        hideButton
      />
    </S.TopBar>
  )
}

export default TopBar
